import { Collection } from 'es6/components/collection'
import { Defaults } from 'es-decorators'
import { entryScriptName } from 'init/entry-script-name'
import { Model } from 'es6/components/model'
import remove from 'lodash/remove'
import findKey from 'lodash/findKey'
import Backbone from 'init/backbone'

/**
 * Коллекция доставки товаров
 */
@Defaults({
  model: Model,
  url: `${entryScriptName}/api/v4/item-delivery/`,
  lastSync: null,
  /**
   * Объект хранящий применённые модификаторы товаров.
   * Ключ объекта является изначальным id товара.
   * Значение объекта является выбранным модификатором.
   * @type {Object<string, string>}
   */
  appliedModifiers: {},
})
export class ItemDeliveryCollection extends Collection {
  /** @inheritDoc */
  run (models, options) {
    if (typeof options === 'object' && options.hasOwnProperty('settlement')) {
      this.listenTo(options.settlement, 'change:settlement_id', this.clearAppliedModifiers)
    }
    this.listenTo(Backbone, 'change-currency apply-viewtype', this.clearAppliedModifiers)
  }

  /**
   * Отчищает объект применённых модификаторов.
   */
  clearAppliedModifiers () {
    this.appliedModifiers = {}
  }

  /**
   * Запрос доставок товаров
   * @param {Array} ids Массив идентификаторов товаров
   */
  requestItemDelivery (ids) {
    if (this.lastSync && this.lastSync.abort) {
      this.lastSync.abort()
    }
    if (Object.keys(this.appliedModifiers).length) {
      const itemsIdsWithAppliedModifiers = Object.keys(this.appliedModifiers)
      ids = remove(ids, itemId => {
        return !itemsIdsWithAppliedModifiers.includes(String(itemId))
      })
      ids = ids.concat(Object.values(this.appliedModifiers))
    }
    this.lastSync = this.sync('create', this, {
      data: {
        ids: ids.join(','),
      },
      url: `${entryScriptName}/api/v4/item-delivery/`,
      wait: true,
      method: 'POST',
      success: data => {
        this.reset(data)
        this.lastSync = null
      },
      processData: true,
    })
  }

  /**
   * Устанавливает id модификатора в объект примененных модификаторов.
   * Если до этого уже было переключение модификатора в товаре, устанавливает в изначальный ключ/id товара.
   * @param {string} currentItemId Текущий модификатор товара.
   * @param {string} chosenModifierItemId Идентификатор примененного товара-модификатора.
   */
  setAppliedModifier (currentItemId, chosenModifierItemId) {
    // Если у товара выбирался модификатор - он должен присутствовать в значении изначального ключа-идентификатора.
    const initialItemId = findKey(this.appliedModifiers, function (value) {
      return String(value) === String(currentItemId)
    })
    if (typeof initialItemId !== 'undefined') {
      currentItemId = initialItemId
    }
    this.appliedModifiers[currentItemId] = chosenModifierItemId
  }
}
